import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "operation-item" }
const _hoisted_2 = { class: "operation-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "operation-info" }
const _hoisted_5 = { class: "operation-title" }
const _hoisted_6 = ["innerHTML"]

import { computed, onMounted, ref, watch } from 'vue'
import { FormType, OpenStatus } from '@/enum'
import { setApptitle, isInAppWebview } from '@/utils/native-app'
import useOpenInfo from '@/hooks/openInfo'
import * as storage from '@/utils/storage'
import redirectUrl from '@/utils/redirect-url'
import { Form, useClientFormDraftAll } from '@/hooks/useClientFormDraftAll'


export default /*@__PURE__*/_defineComponent({
  __name: 'openAccount',
  props: {
  data: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: String,
    default: 'openAccount'
  }
},
  setup(__props) {

const props = __props

const { title } = useOpenInfo()
setApptitle(title)
const isApp = isInAppWebview()

watch(props.data, (n) => {
  status.value = n.customStatus
})

// 查询全部缓存表信息
const { queryAccountInfo, queryImmigrantAccountInfo, formName, status } =
useClientFormDraftAll(Form.HOME, props.type)

const goPage = async () => {
  formName.value = props.data.routerName
  if (props.type === FormType.OPEN_IMMIGRANT_ACCOUNT) {
    queryImmigrantAccountInfo()
  } else {
    queryAccountInfo()
  }

  // if (name) {
  //   if (name === RouterName.TRANSFER_STEP && OpenStatus.SUPPLEMENT === 13) {
  //     router.push({ name, query: { type: props.type, hide: 'hide' } })
  //   } else {
  //     router.push({ name, query: { type: props.type } })
  //   }
  //   storage.set('formType', props.type)
  // }
}

const toLogin = () => {
  if (isApp) return
  redirectUrl()
  storage.clear()
}

onMounted(() => {
  status.value = props.data.customStatus
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.data.iconImagesUrl
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.data.text), 1),
        (__props.data.btnText !== '立即开户')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "operation-tip",
              innerHTML: __props.data.btnTips
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.data.customStatus === _unref(OpenStatus).DONE)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "operation-btn",
          onClick: toLogin
        }, "完成开户"))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "operation-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goPage()))
        }, _toDisplayString(__props.data.btnText), 1))
  ]))
}
}

})